// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1KjHH","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3a6MU"};